var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ordinal = require('ordinal');
var indicator = require('ordinal/indicator');
var stable = require('stable');
var slugify = require('../utils/slugify.js');

function Company(el) {
  var $el = $(el),
      $issueChart = $el.find('#driver-chart'),
      $componentChart = $el.find('#component-chart'),
      $metricChart = $el.find('#metric-chart'),
      $scoreExplainer = $el.find('#score-explainer'),
      $currentYear = $el.find('.company-header__scores').attr('data-year'),
      $companyData = '/wp-content/themes/justcapital/assets/data/companies.json',
      $industryData = '/wp-content/themes/justcapital/assets/data/industries.json',
      $performanceData = '/wp-content/themes/justcapital/assets/data/performance.json',
      $issuesData = '/wp-content/themes/justcapital/assets/data/methodology_metadata.json',
      $companySlug = window.location.pathname.split('/')[2],
      $companies,
      $industries,
      $averages,
      $issues,
      $company,
      $companyLastYear,
      $scores,
      $bestOverallScore,
      $industry = '';

  $.getJSON($companyData, function(data) {
    $companies = data;
    data.forEach(function(company) {
      if (slugify(company.name) === $companySlug) {
        $company = company;
        $industry = $company.industry;
        $scores = $company.scores;
        $.getJSON($industryData, function(data) {
          $industries = data;
          $industries.forEach(function(industry) {
            if (industry.name === $company.industry) {
              $averages = industry.scores;
              showCompany();
            }
          });
        });
      }
      if (company.rank.overall == 1) {
        $bestOverallScore = Math.round(company.scores.overall * 10) / 10;
      }
    });
  });

  $.getJSON($issuesData, function(data) {
    $issues = data;
    $issues.forEach(function(issue) {
      var tempHTML= '<li data-issue="' 
      tempHTML+= issue.website_id 
      tempHTML+= '" data-component="overall" data-name="' 
      tempHTML+= issue.name 
      tempHTML+= '"><div class="data__summary">'
      tempHTML+= '<p class="data__summary-name">' + issue.name + '</p>'
      tempHTML+= '<p class="hidden-sm">' + issue.excerpt + '</p>'
      tempHTML+= '<p class="data__weight">Ranking weight: ' 
      tempHTML+= Math.round(issue.weight)
      tempHTML+= '%'
      if(!is_locked)
      {
        tempHTML+= ' <a href="#" class="hidden-sm js-show-components">Learn more</a>'
      }
      tempHTML+= '</p></div><div class="data__chart js-show-components"><div class="chart-bar"></div></div><div class="data__ranks">'
      if(!is_locked)
      {     
        tempHTML+= '<a href="/rankings?issue=' + issue.website_id + '"><span class="data__ranks-overall ordinal"></span> overall</a>'
        tempHTML+= '<a href="/rankings"><span class="data__ranks-industry ordinal"></span> in industry</a>'
      }
      tempHTML+= '</div></li>';
      $issueChart.find('ul').append(tempHTML)
    });
  });

  // Show component chart
  $issueChart.on('click', '.js-show-components', function(e) {
    e.preventDefault();
    if(!is_locked)
    {
      var $issue = $(this).closest('li'),
          $issueName = $issue.attr('data-name'),
          $dataCode = $issue.attr('data-issue'),
          $chartRows = '';
      $issueChart.hide();
      $componentChart.find('.data__feature span').text($issueName);
      $issues.forEach(function(issue) {
        if (issue.website_id === $dataCode) {
          issue.components.forEach(function(component) {
            var $metricsLink = (component.metrics.length) ?' <a href="#" class="hidden-sm js-show-metrics">Learn more</a>' : '',
                $chartClasses = (component.metrics.length) ? 'data__chart js-show-metrics' : 'data__chart';
            var tempHTML= '<li data-issue="' 
            tempHTML+= $dataCode 
            tempHTML+= '" data-component="' 
            tempHTML+= component.component 
            tempHTML+= '" data-metric="overall" data-name="' 
            tempHTML+= component.name 
            tempHTML+= '"><div class="data__summary"><p class="data__summary-name">' + component.name + '</p>'
            tempHTML+= '<p class="hidden-sm">' + component.excerpt + '</p>'
            tempHTML+= '<p class="data__weight">Ranking weight: ' + parseFloat(component.weight).toFixed(1) + '% ' + $metricsLink + '</p></div>'
            tempHTML+= '<div class="' + $chartClasses + '"><div class="chart-bar"></div></div>'
            tempHTML+= '<div class="data__ranks"><a href="/rankings?issue=' + $dataCode + '&component=' + component.component + '"><span class="data__ranks-overall ordinal"></span> overall</a>'
            tempHTML+= '<a href="/rankings"><span class="data__ranks-industry ordinal"></span> in industry</a>'
            tempHTML+= '</div></li>';
            $chartRows+= tempHTML;
          });
        }
      });
      $componentChart.find('ul').html($chartRows);
      $componentChart.show();
      showScores($componentChart);
      $('html, body').animate({
        scrollTop: $componentChart.offset().top
      }, 300);
    }
  });

  // Show metric chart
  $componentChart.on('click', '.js-show-metrics', function(e) {
    e.preventDefault();
    var $component = $(this).closest('li'),
        $componentName = $component.find('.data__summary-name').text(),
        $issueKey = $component.attr('data-issue'),
        $componentKey = $component.attr('data-component'),
        $metricRows = '';
    $componentChart.hide();
    $metricChart.find('.data__feature span').text($componentName);
    $issues.forEach(function(issue) {
      if (issue.website_id === $issueKey) {
        issue.components.forEach(function(component) {
          if (component.component === $componentKey) {
            component.metrics.forEach(function(metric) {
              $metricRows += '<li data-issue="' + $issueKey + '" data-component="' + $componentKey + '" data-metric="' + metric.website_id + '" data-name="' + metric.name + '"><div class="data__summary"><p class="data__summary-name">' + metric.name + '</p></div><div class="data__chart"><div class="chart-bar"></div></div><div class="data__ranks"><p><span class="data__ranks-overall ordinal"></span> overall</p><p><span class="data__ranks-industry ordinal"></span> in industry</p></div></li>';
            });
          }
        });
      }
    });
    $metricChart.find('ul').html($metricRows);
    $metricChart.show();
    showScores($metricChart);
    $('html, body').animate({
      scrollTop: $metricChart.offset().top
    }, 300);
  });

  // Hide component chart
  $el.find('.js-close-component-view').on('click', function(e) {
    e.preventDefault();
    $componentChart.hide();
    $issueChart.show();
  });

  // Hide metric chart
  $el.find('.js-close-metric-view').on('click', function(e) {
    e.preventDefault();
    $metricChart.hide();
    $metricChart.find('ul').empty();
    $componentChart.show();
  });

  function showCompany() {
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function nFormatter(num) {
      if (num >= 1000000000) return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
      if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      return num;
    }

    var $score = $company.scores.overall ? Math.round($company.scores.overall * 10) / 10 : '',
        $rank = parseInt($company.rank.overall),
        $ordinalRank = $rank ? $rank + '<span>' + indicator($rank) + '</span>' : '<span>Not displayed</span>';
        $industryRank = parseInt($company.rank.industry);

    $el.find('#ticker').append('<strong>Ticker:</strong> ' + $company.ticker);
    $el.find('.company-shortname').text($company.short_name);
    $el.find('.compare-link').attr('href', '/compare/?co=' + $company.ticker);
    $el.find('.industry-name').text($industry);
    // $el.find('.industry-link').attr('href', '/rankings?industry=' + slugify($industry));
    $el.find('.overall-score').text($score);
    if($score=="")
    {
      $el.find('#score-explainer').hide()
    }
    $el.find('#best-overall-score').text($bestOverallScore);


    if ($company.marketcap) $el.find('#marketcap').append('<strong>Market Cap:</strong> $' + nFormatter($company.marketcap * 1000000));
    if ($company.number_of_employees) $el.find('#employees').append('<strong>Global Employees:</strong> ' + numberWithCommas($company.number_of_employees));
    // if ($company.in_julcd == "1") {
    //   var tempHTML = 'Ranked in the top half of the '+$industry+' industry and included in the <a href="/value-of-just-business">JUST ETF / JULCD Index</a>'
    //   if ($rank && $rank <= 100) {
    //     tempHTML+=' and the <a href="/value-of-just-business">JUST 100 Index</a>';
    //   }
    //   $el.find('#julcd').append(tempHTML);
    // }

    if($company.data_addendum){
      $el.find('.rankings_notification').append('<b>DATA CLARIFICATION:</b> '+$company.data_addendum.description);
      $el.find('.rankings_notification').show();
    }

    if ($company.data_clarification) {
      $el.find('.company-profile').append('<div class="company-profile__clarification container"><div class="row"><div class="col-12 col-md-8 offset-md-2"><h3><a name="clarification">Data Clarification</a></h3><p>' + $company.data_clarification.description + '</p></div></div></div>');
    } else {
      var tempHTML = "";
      tempHTML+= '<p>';
      
      tempHTML+= '<span id="industry-rank" class="ordinal">' 
      tempHTML+= $industryRank 
      tempHTML+= '<span>'
      tempHTML+= indicator($industryRank);
      tempHTML+= '</span>'
      tempHTML+= '</span>'
      tempHTML+= '<span class="hidden-lg">in industry</span>'
      tempHTML+= '<span class="hidden-sm">'
      tempHTML+= 'of <span id="industry-total"></span> '
      //tempHTML+= '<a href="/rankings?industry=' + slugify($industry) + '" class="industry-name industry-link">' 
      tempHTML+= '<a href="/news/industry-leaders-just-100-2024/"  class="industry-name industry-link">'
      tempHTML+= $industry 
      tempHTML+= '</a>'
      tempHTML+= ' companies</span>'

      if ($company.in_julcd == "1") {
        tempHTML += '<br/>Included in <br/><a href="/value-of-just-business">JUST ETF / JULCD Index</a> '
        tempHTML += 'by performing in the <strong>top half</strong> of the '+$industry+' industry.'
      }

      tempHTML+= '</p>';
      $el.find('.company-header__scores').prepend(tempHTML);
      if ($rank) {
        var tempHTML = '<p>'
        tempHTML+='<span id="rank" class="ordinal">';
        if($company.data_addendum)
        {
          tempHTML+='';
        }
        else
        {
          tempHTML+=$ordinalRank
        }
        tempHTML+='</span>';
        tempHTML+='<span class="hidden-lg">overall</span>'
        tempHTML+='<span class="hidden-sm">';
        
        if($company.data_addendum)
        {
          tempHTML+='';
        }
        else
        {
          tempHTML+='of <a href="/rankings">' + $companies.length + ' companies.</a></span>';
        }

        if ($rank && $rank <= 100) {
          tempHTML+='<br/>Included in the <br/><a href="/value-of-just-business">JUST 100 Index</a>';
        }
        tempHTML+='</p>'
        $el.find('.company-header__scores').prepend(tempHTML);
      } else {
        $el.find('#company-seals').remove()
        $el.find('#industry-seals').remove()
          $el.find('.company-header__scores').append('<div class="company-header__note"><p>Bottom 10%</p><p>' + $company.name + ' is ranked in the bottom 10% of companies overall. We don\'t display overall rankings or scores for the bottom 10%.</p></div>');
      }
      if ($score) $issueChart.find('.data__feature').append('<span class="section-label">Overall score</span> ' + $score);

      // Total number of companies in the industry
      var $industryTotal = $companies.filter(function(companies) {
        return companies.industry === $industry;
      });
      $el.find('#industry-total').text($industryTotal.length);

      var $topSeals = '',
          $industrySeals = '';
      if ($rank && $rank <= 100) {
        $topSeals = $currentYear;
        $el.find('#company-seals').append('<span></span> JUST 100 <strong>' + $topSeals + '</strong>');
      }
      if ($industryRank == 1) {
        $industrySeals = $currentYear;
        $el.find('#industry-seals').append('<span></span> Industry Leader <strong>' + $industrySeals + '</strong>');
      }

      if ($company.under_review) {
        $el.find('#company-seals').html("")
        $el.find('#industry-seals').html("")
        $el.find('#rankings-review strong').html("Under Review")
        if ($company.under_review.description) {
          $el.find('#rankings-review-text').html($company.under_review.description)
        }
      }
      else if ($company.unique_event)
      {
        $el.find('#company-seals').html("")
        $el.find('#industry-seals').html("")
        $el.find('#rankings-review strong').html('<p class="rankings__review"><svg width="35" height="35" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:15px;"><circle cx="41" cy="41" r="41" fill="#DA0707"></circle><rect x="6" y="6" width="70" height="70" rx="35" fill="#FFEFEF"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M34.6094 17.9894C37.4818 13.3975 44.5182 13.3975 47.3907 17.9894L66.4723 48.4933C67.9583 50.8687 67.7639 53.5823 66.4723 55.6469C65.1911 57.6952 62.8547 59.0909 60.0817 59.0909H21.9183C19.1453 59.0909 16.809 57.6952 15.5277 55.6469C14.2361 53.5823 14.0418 50.8687 15.5277 48.4933L34.6094 17.9894ZM44.1502 20.059C42.7823 17.8723 39.2177 17.8723 37.8498 20.059L18.7681 50.5629C18.1339 51.5769 18.2045 52.6763 18.7681 53.5773C19.342 54.4947 20.451 55.2174 21.9183 55.2174H60.0817C61.5491 55.2174 62.658 54.4947 63.2319 53.5773C63.7955 52.6763 63.8662 51.5769 63.2319 50.5629L44.1502 20.059ZM41 24.5527C42.0586 24.5527 42.9168 25.4198 42.9168 26.4894V40.2075C42.9168 41.2771 42.0586 42.1443 41 42.1443C39.9414 42.1443 39.0833 41.2771 39.0833 40.2075V26.4894C39.0833 25.4198 39.9414 24.5527 41 24.5527ZM41 47.3089C42.0586 47.3089 42.9168 48.1761 42.9168 49.2457V50.3755C42.9168 51.4451 42.0586 52.3122 41 52.3122C39.9414 52.3122 39.0833 51.4451 39.0833 50.3755V49.2457C39.0833 48.1761 39.9414 47.3089 41 47.3089Z" fill="#DA0707"></path></svg></p>')
        if ($company.unique_event.description) {
          $el.find('#rankings-review-text').html($company.unique_event.description)
        }
      } 
      else
      {
        $el.find('#rankings-review').hide()
      }

      for (var p = 1; p < 7; p++) {
        if ($company.unique_event)
        {
          continue;
        }
        var $prevYear = $currentYear - p;
        $.ajax({
          url: '/wp-content/themes/justcapital/assets/data/companies-' + $prevYear + '.json',
          async: false,
          success: function(data) {
            var $prevYearRank,
                $prevYearIndustryRank,
                $companyFound;
            $companyFound=false;
            data.forEach(function(c) {
              if (c.ticker === $company.ticker)
              {
                $companyLastYear = c;
                $companyFound=true;
              }
            });
            if ($companyFound) {
              $prevYearRank = $companyLastYear.rank.overall;
              $prevYearIndustryRank = $companyLastYear.rank.industry;
            
              if ($prevYearRank && $prevYearRank <= 100) {
                if ($topSeals) {
                  $el.find('#company-seals strong').append(', ' + $prevYear);
                } else {
                  $topSeals = $prevYear;
                  $el.find('#company-seals').append('<span></span> JUST 100 <strong>' + $topSeals + '</strong>');
                }
              }
              if ($prevYearIndustryRank == 1) {
                if ($industrySeals) {
                  $el.find('#industry-seals strong').append(', ' + $prevYear);
                } else {
                  $industrySeals = $prevYear;
                  $el.find('#industry-seals').append('<span></span> Industry Leader <strong>' + $industrySeals + '</strong>');
                }
              }

            }

          }
        });
      }
    }

    // Company's performance by the numbers
    showScores($issueChart);

    // Company's performance
    showPerformance();
  }

  function showScores(chart) {
    chart.find('li').each(function() {
      var $issue = $(this).attr('data-issue'),
          $component = $(this).attr('data-component'),
          $metric = $(this).attr('data-metric'),
          $clarification;

      if ($company.data_clarification) {
        var $clarificationMetric = $company.data_clarification.datapoints[0].toLowerCase();
        if ($metric && $metric !== 'overall') {
          if ($metric === $clarificationMetric.split('.')[2]) $clarification = true;
        } else {
          if ($component === 'overall' && $issue === $clarificationMetric.split('.')[0]) {
            $clarification = true;
          } else {
            if ($component === $clarificationMetric.split('.')[1]) $clarification = true;
          }
        }
      }

      if($company.data_addendum) {
        for(var da=0;da<$company.data_addendum.datapoints.length;da++)
        {
          var data_addendum = false;  
          var data_elements = $company.data_addendum.datapoints[da].split('.');
          if(data_elements.length==3 && $metric && $metric==data_elements[2]) {
            data_addendum=true;
          }
          else if(data_elements.length==2 && $component && $component==data_elements[1]) {
            data_addendum=true;
          }
          else if(data_elements.length==1 && $issue && $issue==data_elements[0]) {
            data_addendum=true;
          }
          if(data_addendum){
            $(this).find('.chart-bar').parent().remove();
            $(this).find('.data__ranks').remove();
            $(this).find('.data__summary').after('<div class="data__clarification"><a href="#clarification">DATA CLARIFICATION</a><div>'+$company.data_addendum.description+'</div></div>');
          }
        }
      }

      if ($clarification) {
        $(this).find('.chart-bar').parent().remove();
        $(this).find('.data__ranks').remove();
        $(this).find('.data__summary').after('<div class="data__clarification"><a href="#clarification">DATA CLARIFICATION</a></div>');
      } else {
        var $score = $metric ? Math.round($scores[$issue][$component][$metric]) : Math.round($scores[$issue][$component]),
            $score_winsorized = ($score<(0-25))?0-25:(($score>150)?150:$score),
            $industry_average = $component === 'overall' ? Math.round($averages[$issue]['ind_mean']) : $metric === 'overall' ? Math.round($averages[$issue][$component]['ind_mean']) : Math.round($averages[$issue][$component][$metric]['ind_mean']),
            $industry_max = $component === 'overall' ? Math.round($averages[$issue]['ind_max']) : $metric === 'overall' ? Math.round($averages[$issue][$component]['ind_max']) : Math.round($averages[$issue][$component][$metric]['ind_max']),
            $overall_max = $component === 'overall' ? Math.round($averages[$issue]['overall_max']) : $metric === 'overall' ? Math.round($averages[$issue][$component]['overall_max']) : Math.round($averages[$issue][$component][$metric]['overall_max']),
            $chartWidth = chart.find('.data__chart').width(),
            $offset = ((25 * $chartWidth) / 150) / $chartWidth * 100,
            $width = ((Math.abs($score_winsorized) * $chartWidth) / 150) / $chartWidth * 100,
            $style = {
              'margin-left': ($score_winsorized >= 0) ? ($offset + '%') : (((($score_winsorized * $chartWidth) / 150) / $chartWidth * 100 + $offset) + '%'),
              'width': $width + '%',
              'height': '60px',
              'opacity': '0'
            },
            $industryAverageMarkerStyle = 'left: ' + ($offset + (((Math.abs($industry_average) * $chartWidth) / 150) / $chartWidth * 100)) + '%';
            $industryMaxMarkerStyle = 'left: ' + ($offset + (((Math.abs($industry_max) * $chartWidth) / 150) / $chartWidth * 100)) + '%';
            $overallMaxMarkerStyle = 'left: ' + ($offset + (((Math.abs($overall_max) * $chartWidth) / 150) / $chartWidth * 100)) + '%';

        $(this).find('.chart-bar').html('<div class="industry-average chart-marker" style="' + $industryAverageMarkerStyle + '"><span>' + $industry_average + '</span></div><div class="industry-max chart-marker" style="' + $industryMaxMarkerStyle + '"><span class="industry-max">' + $industry_max + '</span></div><div class="overall-max chart-marker" style="' + $overallMaxMarkerStyle + '"><span>' + $overall_max + '</span></div><span class="co-score">' + $score + '</span>').css($style).addClass('visible');
        var $marker = $(this).find('.chart-marker');
        setTimeout(function() {
          $marker.addClass('visible');
        }, 300);
        showRanks(chart, $(this).attr('data-name'), $issue, $component, $metric);
      }
    });
  }

  function showRanks(chart, row, issue, component, metric) {
    // Company's overall rank for each issue/component/metric
    var $row = chart.find('li[data-name="' + row + '"]');
    function sort(x,y) {
      if (metric) {
        return y.scores[issue][component][metric] - x.scores[issue][component][metric];
      } else {
        return y.scores[issue][component] - x.scores[issue][component];
      }
    }
    var $issueSort = stable($companies, sort);
    var $issueRank = -1;
    for (var i = 0; i < $issueSort.length; i++) {
      if (metric) {
        if ($issueSort[i].scores[issue][component][metric] == $company.scores[issue][component][metric]) {
          $issueRank = i;
          break;
        }
      } else {
        if ($issueSort[i].scores[issue][component] == $company.scores[issue][component]) {
          $issueRank = i;
          break;
        }
      }
    }
    $issueRank = $issueRank + 1;
    var $issueTie = 0;
    $companies.forEach(function(co) {
      if (metric) {
        if (co.scores[issue][component][metric] == $company.scores[issue][component][metric]) $issueTie++;
      } else {
        if (co.scores[issue][component] == $company.scores[issue][component]) $issueTie++;
      }
    });
    var $issueTieLabel = ($issueTie > 1) ? ' (tied)' : '';
    $row.find('.data__ranks-overall').html($issueRank + '<span>' + indicator($issueRank) + '</span>').parent().append($issueTieLabel);
    if (component === 'overall') $row.find('.data__ranks-overall').parent().attr('href', '/rankings?issue=' + issue);

    // Company's rank in its industry for each issue/component
    var $filtered = $issueSort.filter(function(companies) {
      return companies.industry === $industry;
    });
    var $industryRank = -1;
    for (var i = 0; i < $filtered.length; i++) {
      if (metric) {
        if ($filtered[i].scores[issue][component][metric] == $company.scores[issue][component][metric]) {
          $industryRank = i;
          break;
        }
      } else {
        if ($filtered[i].scores[issue][component] == $company.scores[issue][component]) {
          $industryRank = i;
          break;
        }
      }
    }
    $industryRank = $industryRank + 1;
    var $industryTie = 0;
    $filtered.forEach(function(co) {
      if (metric) {
        if (co.scores[issue][component][metric] == $company.scores[issue][component][metric]) $industryTie++;
      } else {
        if (co.scores[issue][component] == $company.scores[issue][component]) $industryTie++;
      }
    });
    var $industryTieLabel = ($industryTie > 1) ? ' (tied)' : '';
    $row.find('.data__ranks-industry').html($industryRank + '<span>' + indicator($industryRank) + '</span>').parent().append($industryTieLabel);
    if (component === 'overall') $row.find('.data__ranks-industry').parent().attr('href', '/rankings?issue=' + issue + '&industry=' + slugify($industry));
  }

  function showPerformance() {
    $.getJSON($performanceData, function(data) {
      var $performance = data[$company.ticker];
      if (typeof $performance != "undefined" && $performance.length !== 0) {
        var $cards = '';
        for (var key in $performance) {
          var $performanceArea = $performance[key],
              $sentiment = ($performanceArea.sentiment == '1') ? 'Strength' : 'Area for Improvement',
              $writeups = $performanceArea.writeups,
              $analysis = '';
          for (var item in $writeups) $analysis += '<p>' + $writeups[item] + '</p>';
          $cards += '<div class="company-detail-card"><div class="company-detail-card__heading"><p class="section-label">' + $sentiment + '</p><p class="company-detail-card__issue">' + $performanceArea.stakeholder + '</p><p>' + $performanceArea.flashline + '</p></div><div class="company-detail-card__analysis">' + $analysis + '</div></div>';
        }
        $scoreExplainer.after('<div class="company-details container"><h2><a name="performance">Dig Deeper:</a> How ' + $company.short_name + ' earned its scores</h2>' + $cards + '</div>');
      }
    });
  }
}

module.exports = Company;
